module.exports = __webpack_public_path__ + "talk.svg?ddd7335e8e7fb99c170d5ab0d8ebabb4";